<template>
  <!-- A footer containing copyrights and stuffs  -->
  <footer id="stickyfooter" class="footer mt-auto">
    <div id="title-container" class="container">
      <a href="https://uclouvain.be/en/research-institutes/ilc/cecl">Centre for English Corpus Linguistics</a> Prof. dr. S. Granger, dr. M. Paquot, dr. M.-A. Lefer<br/>
      <a href="https://ilt.kuleuven.be/">Interfacultair instituut voor levende talen</a> dr. K. Blanpain, C. Coppens, G. Peeters, Prof. dr. S. Verlinde
    </div>
  </footer>
</template>

<script>
export default {
  name: 'StickyFooter',
  props: {
    title: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#stickyfooter {
  overflow: hidden;
  background-color: #00214e;
  /* position: fixed;
  bottom: 0; */
  width: 100%;
  height: 8vh;
  min-height: 8vh;
  display : flex;
  z-index: 200;
}

#title-container {
  font-size: 1vw;
  color: rgba(255, 255, 255, 0.8);
  height: 80%;
  width: 100%;
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
}

a {
  color : #03a5fc;
}

/* Phone display */
@media screen and (max-width: 850px) and (orientation: portrait){
  #title-container {
    font-size: 2vw;
  }
}

/* Wide small screen display */
@media screen and (max-width: 850px) and (orientation: landscape){
  #title-container {
    font-size: 1.1vw;
  }
}

</style>
